// TODO: fix this (maybe upgrading to the yup@next version) workaround -> https://github.com/jquense/yup/issues/293
export const locale = {
  mixed: {
    default: 'yup.errors.invalid_format',
    required: 'yup.errors.required',
  },
  string: {
    matches: 'yup.errors.invalid_format',
    email: 'yup.errors.invalid_email_format',
    min: ({ min }: { min: number }) => ({
      key: 'yup.errors.string.min',
      values: { min },
    }),
    max: ({ max }: { max: number }) => ({
      key: 'yup.errors.string.max',
      values: { max },
    }),
  },
  number: {
    min: ({ min }: { min: number }) => ({
      key: 'yup.errors.number.min',
      values: { min },
    }),
    max: ({ max }: { max: number }) => ({
      key: 'yup.errors.number.max',
      values: { max },
    }),
    positive: () => ({
      key: 'yup.errors.number.positive',
    }),
  },
  date: {
    min: ({ min }: { min: any }) => ({
      key: 'yup.errors.date.min',
      values: { min },
    }),
  },
}
